export default __webpack_public_path__ + "static/media/icon_ihmiset_aloittamatta.e92792ce.svg";